import { Component } from '@angular/core';
import { Transition } from '@uirouter/core';

import { BillingApiService } from 'src/app/api/services/billing-api.service';
import {
  ScrollingListFactoryService,
  ScrollingListInstance,
} from 'src/app/components/scrolling-list/services/scrolling-list-factory.service';
import { InvoiceService } from '../../services/invoice.service';

@Component({
  selector: 'unpaid-invoices',
  templateUrl: './unpaid-invoices.component.html',
  styleUrls: ['./unpaid-invoices.component.scss'],
  standalone: false,
})
export class UnpaidInvoicesComponent {
  unpaidInvoices: ScrollingListInstance = this.scrollingListFactory.create(
    this.billingApiService.getUnpaidInvoices.bind(this.billingApiService),
    {
      companyId: this.transition.params().cid,
      token: this.transition.params().token.replaceAll(' ', '+'),
      name: 'Unpaid Invoices',
    },
  );

  constructor(
    private transition: Transition,
    private scrollingListFactory: ScrollingListFactoryService,
    private billingApiService: BillingApiService,
    public invoiceService: InvoiceService,
  ) {
    this.invoiceService.generateToken();
  }
}
